import { render, staticRenderFns } from "./PhysicianEditTabAccount.vue?vue&type=template&id=161de87f&"
import script from "./PhysicianEditTabAccount.vue?vue&type=script&lang=js&"
export * from "./PhysicianEditTabAccount.vue?vue&type=script&lang=js&"
import style0 from "./PhysicianEditTabAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports